import { useState } from "react";
import { Button, Tabs, Tab, Card, CardBody } from "react-bootstrap";
import { motion } from "framer-motion";

function Admision() {
  const [selectedTab, setSelectedTab] = useState("proceso");
  const planillas = [
    {
      label: "Nivel Inicial",
      url: "https://drive.google.com/file/d/1wF6MoNhU9gVGlWxqNodpTpOqkHSjM-GE/view?fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGn8iZqO581kDTrAi43YZpOwukUHPITHw_QY5vMoi4IX8UX1eNVPEtFpaAAuPM_aem_5CgjQ61eiVlGwPA_TMhRZA",
    },
    {
      label: "Nivel Primario",
      url: "https://drive.google.com/file/d/1Lf5NNHxMwULLadCH260h-KIogq4Yv6Zt/view?fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnXNLAO1ghltsXWKVZJQljsU2BRFl5Jh-WAzhgrhOB7CqjRBSbXC-AaE6yYuI_aem_Weiwa5iciGvbhvb_OH3SOw",
    },
    {
      label: "Nivel Secundario",
      url: "https://drive.google.com/file/d/1heNeX7YwVNVXZs83_PqfZQ1CglAPjpFS/view?fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGn2ZcK6FXZycCrtNkzv0sYIHuXOqsNrM8iN6gjzW9jQjGmnwnJFAa2kloiQHg_aem_Fo1xmZqS0sB3UyI--z4Rgw",
    },
  ];

  return (
    <div className="container text-center py-4" data-aos="fade-up">
      <div className="mt-4 mb-4">
          <p className="text-uppercase fw-semibold text-warning mb-2">Admisiones</p>
          <h1 className="display-5 fw-bold mb-3">Pre-inscripciones 2027</h1>
          <p className="lead mb-0 mx-auto" style={{ maxWidth: "720px" }}>
            Conocé el proceso de admisión y descargá la planilla correspondiente al nivel educativo.
          </p>
      </div>
      {/* Submenú de navegación con Tabs */}
      <Tabs activeKey={selectedTab} onSelect={(k) => setSelectedTab(k)} className="mb-4 justify-content-center" data-aos="fade-up">
        <Tab eventKey="proceso" title="Proceso de Admisión">
          <Card className="border-0 shadow-sm mb-4 text-start bg-light p-4 rounded-4">
            <CardBody className="p-0 p-md-2">
 
              <h4  className="fw-bold fs-5 mb-3">Importante</h4>
              <p className="mb-3">Las pre-inscripciones 2027 están abiertas para:</p>
              <ul className="list-unstyled d-grid gap-2 mb-0">
                <li className="d-flex align-items-center gap-2"><span className="badge text-bg-warning rounded-pill">✓</span> Nivel Inicial</li>
                <li className="d-flex align-items-center gap-2"><span className="badge text-bg-warning rounded-pill">✓</span> Nivel Primario</li>
                <li className="d-flex align-items-center gap-2"><span className="badge text-bg-warning rounded-pill">✓</span> Nivel Secundario</li>
              </ul>
      
 
            </CardBody>
          </Card>
        </Tab>

        <Tab eventKey="calendario" title="Calendario de Admisiones">
          <Card className="border-0 shadow-sm mb-4 text-start bg-light p-4 rounded-4">
            <CardBody className="p-0 p-md-2">
 
              <h4 className="fw-bold text-primary mb-3">Fechas Importantes</h4>
              <ul className="list-unstyled d-grid gap-3 mb-0">
                <li className="d-flex align-items-start gap-2"><span>📅</span><span>Inscripciones abiertas desde Mayo 2026.</span></li>
                <li className="d-flex align-items-start gap-2"><span>📅</span><span>Entrega de documentación hasta Junio 2026.</span></li>
                <li className="d-flex align-items-start gap-2"><span>📅</span><span>Entrevistas en Mayo / Junio  2026.</span></li>
                
 
              </ul>
            </CardBody>
          </Card>
        </Tab>

        <Tab eventKey="matriculacion" title="Matriculación">
          <Card className="border-0 shadow-sm mb-4 text-start bg-light p-4 rounded-4">
            <CardBody className="p-0 p-md-2">
              <h4  className="fw-bold fs-5 mb-3">Proceso de Matriculación</h4>
              <p>
                Una vez admitidos, los estudiantes deberán completar el proceso de matriculación, que incluye:
              </p>
              <ul className="list-unstyled d-grid gap-2 mt-3 mb-0">
                <li className="d-flex align-items-center mb-2">📌 Pago de matrícula.</li>
                <li className="d-flex align-items-center mb-2">📌 Presentación de documentos requeridos.</li>
                <li className="d-flex align-items-center mb-2">📌 Confirmación de vacante.</li>
              </ul>
            </CardBody>
          </Card>
        </Tab>

        <Tab eventKey="faq" title="Preguntas Frecuentes">
          <Card className="border-0 shadow-sm mb-4 text-start bg-light p-4 rounded-4">
            <CardBody className="p-0 p-md-2">
              <h4 className="fw-bold fs-5 mb-3">Preguntas Frecuentes</h4>
              <p><strong className="fw-bold">¿Cuáles son los requisitos de ingreso?</strong><br/>Los requisitos varían por nivel educativo. Contacta con la institución para más detalles.</p>
              <p><strong className="fw-bold">¿Se ofrecen becas?</strong><br/>Sí, hay becas disponibles para familias con necesidad económica.</p>
              <p><strong className="fw-bold">¿Cuándo inician las clases?</strong><br/>El ciclo lectivo inicia en marzo de cada año.</p>
            </CardBody>
          </Card>
        </Tab>
      </Tabs>

 
        {/* Botones para descargar las planillas */}
<motion.div
  initial={{ opacity: 0, y: 10 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.5, delay: 0.2 }}
  className="mt-4 row g-3 justify-content-center"
>
  {planillas.map((planilla) => (
    <a
      key={planilla.label}
      href={planilla.url}
      target="_blank"
      rel="noopener noreferrer"
      className="col-12 col-md-4 text-decoration-none"
    >
      <Button variant="warning" className="w-100 border-0 rounded-4 px-4 py-3 shadow-sm fw-semibold d-flex flex-column align-items-center gap-1">
        <span className="small text-uppercase">Descargar Planilla</span>
        <span className="fs-5">{planilla.label}</span>
      </Button>
    </a>
  ))}
</motion.div>
 
      
    </div>
  );
}

export default Admision;
